import React from 'react';

import { useTranslation } from 'react-i18next';

import { MarqueeArrows, MarqueeArrowsDirection } from '@pkg/components';
import { FloorGameIncomingEvent } from '@pkg/types/app/floorGame';

import { Column, Label, MarqueeArrowsWrapper, StyledKeywordMarquee } from './styles';

export interface KeywordMarqueeProps {
    activity: FloorGameIncomingEvent;
}

export function KeywordMarquee({ activity }: KeywordMarqueeProps) {
    const { t: translate } = useTranslation('floorgame');

    if (activity === FloorGameIncomingEvent.Sale) return null;

    const isReceived = activity === FloorGameIncomingEvent.Received;
    const direction = isReceived ? MarqueeArrowsDirection.Left : undefined;
    const labelText = isReceived ? translate('incoming_activity_received') : translate('incoming_activity_sent');

    return (
        <StyledKeywordMarquee>
            <Column>
                <MarqueeArrowsWrapper>
                    <MarqueeArrows direction={direction} />
                </MarqueeArrowsWrapper>
            </Column>

            <Column>
                <Label>{labelText}</Label>
            </Column>

            <Column>
                <MarqueeArrowsWrapper>
                    <MarqueeArrows direction={direction} />
                </MarqueeArrowsWrapper>
            </Column>
        </StyledKeywordMarquee>
    );
}
